<template>
  <div class="bid-row">
    <div class="bid-columns row">
      <div class="col-xs-3 text-right bid-name">{{ bid.name }}</div>
      <div class="col-xs-1">
        <br-switch class="activation-switch"
                   :value="Boolean(bid.is_active)"
                   @input="$emit('toggle-activation', bid.id)">
        </br-switch>
      </div>
      <div class="col-xs-1">{{ bid.todays_click_count | number }}</div>
      <div class="col-xs-1"><span>$</span>{{ bid.todays_cost | currency }}</div>
      <div class="col-xs-1 budget-amount">{{ adSetBudget }}</div>
      <div class="col-xs-1">{{ bid.placement }}</div>
      <div class="col-xs-4">
        <span class="toggle-details" @click.prevent="toggleDetails">
          Details <i class="fa fa-fw" :class="detailsVisible ? 'fa-angle-up' : 'fa-angle-down'"></i>
        </span>
      </div>
    </div>
    <transition name="slide-down">
      <div class="details-wrapper" v-show="detailsVisible">
    <div class="details-row clearfix">
      <div class="row">
        <div class="col-xs-offset-2 col-xs-8 details-body">
          <div class="row">
            <div class="col-xs-4">
              {{ loanTypes || 'All' }}
              <small>Loan Types</small>
            </div>
            <div class="col-xs-4">
              {{ times || 'All' }}
              <small>Time Period</small>
            </div>
            <div class="col-xs-4">
              {{ devices || 'All' }}
              <small>Device Types</small>
            </div>
          </div>
          <div>
            {{ locations || 'All' }}
            <small>States Included</small>
          </div>
          <div v-if="loanAmounts">
            {{ loanAmounts || 'All' }}
            <small>Loan Amounts</small>
          </div>
          <div v-if="creditScores">
            {{ creditScores || 'All' }}
            <small>Credit Scores</small>
          </div>
        </div>
        <div class="col-xs-2">
          <a class="bid-edit-link" :href="`/campaigns/${campaignId}/adset/${adSet.id}/edit?bidId=${bid.id}`">More</a>
        </div>
      </div>
    </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import { formatNumber, formatCurrency } from 'js/utils'

  export default {
    name: 'bid-row',

    props: {
      bid: Object,
      adSetBudget: [String, Number],
      campaignId: [String, Number],
      adSet: Object,
    },

    data () {
      return {
        detailsVisible: false
      }
    },

    computed: {
      details () {
        return this.bid.items
      },

      locations () {
        const locations = (this.details.locations.length) ? this.details.locations : this.adSet.locations
        return locations.map(location => location.id).join(' | ')
      },

      times () {
        return this.details.time_types.map(time => time.label).join(' | ')
      },

      devices () {
        return this.details.device_types.map(device => device.label).join(' | ')
      },

      creditScores () {
        return this.details.fico_ranges.sort((a, b) => a.start > b.start ? -1 : 1)
          .map(range => `${range.start} - ${range.end}`)
          .join(' | ')
      },

      loanTypes () {
        return this.adSet.loan_purposes.map(purpose => purpose.label).join(' | ')
      },

      loanAmounts () {
        return this.details.loan_amount_ranges.sort((a, b) => a.start < b.start ? -1 : 1)
          .map(amount => `$${formatNumber(amount.start)} - $${formatNumber(amount.end)}`)
          .join(' | ')
      }
    },

    methods: {
      toggleDetails () {
        this.detailsVisible = !this.detailsVisible
      }
    }
  }
</script>

<style lang="scss" scoped>
  .bid-row {
    border-top: 1px solid #dedede;
    background-color: #f8f8f8;
    font-size: 14px;
    overflow-x: hidden;
  }

  .bid-columns {
    min-height: 65px;
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .bid-name {
    padding-right: 55px;
  }

  .bid-edit-link {
    cursor: pointer;
  }

  .budget-amount {
    color: rgba(#202020, .33);
  }

  .toggle-details {
    cursor: pointer;
  }

  .details-row {
    background-color: #f8f8f8;
    border-top: 1px solid #dedede;
    font-weight: 600;
    overflow-x: hidden;
    padding: 15px 0;

    > .row {
      align-items: center;
      display: flex;
    }

    small {
      color: #848484;
      display: block;
      font-weight: normal;
    }
  }

  .details-body > div {
    padding-bottom: 5px;
    padding-top: 5px;
  }

  .details-wrapper {
    max-height: 1000px;
    overflow-y: hidden;
  }

  .slide-down-enter-active {
    transition: all .5s ease-in;
  }

  .slide-down-leave-active {
    transition: all .3s ease;
  }

  .slide-down-enter, .slide-down-leave-to, .slide-down-leave-active {
    max-height: 0 !important;
  }
</style>
